var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg max-w1200 mrauto mt47 mb51 pd20"},[_c('div',{staticClass:"pd40 bg-ffffff bor-E6E6E6"},[_c('div',{staticClass:"fs-26 fwb col-CC0000"},[_vm._v(" 使用微信扫码进入小程序： ")]),_c('div',{staticClass:"mrauto wh400 mt20"},[_c('img',{staticClass:"wh400",attrs:{"src":require("../../assets/img/xiaochegnxu.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }